"use strict";

import Vue from "vue";
import https from "https";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import store from "../store";

const config = {
  baseURL:
    process.env.NODE_ENV === "production"
      ? process.env.VUE_APP_API_URL
      : "http://localhost:8085",
  withCredentials: true,
  httpsAgent: new https.Agent({
    rejectUnauthorized: false
  })
};

const _axios = axios.create(config);

_axios.defaults.withCredentials = true;

_axios.interceptors.request.use(
  // Do something before request is sent
  (config: AxiosRequestConfig) => {
    if (store.getters["AuthStore/getAccessToken"] !== "") {
      config.headers.Authorization = `Bearer ${store.getters["AuthStore/getAccessToken"]}`;
    }
    return config;
  },
  // Do something with request error
  (error: any) => Promise.reject(error)
);

// Add a response interceptor
_axios.interceptors.response.use(
  // Do something with response data
  (response: any) => response,
  // Do something with response error
  (error: any) => Promise.reject(error)
);

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function AxiosPlugin(vue: typeof Vue, options?: any): void {
  vue.prototype.$axios = _axios;
}

declare module "vue/types/vue" {
  interface Vue {
    $axios: AxiosInstance;
  }
}

export default AxiosPlugin;
